/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FailureStatusVm,
    FailureStatusVmFromJSON,
    FailureStatusVmFromJSONTyped,
    FailureStatusVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface FailureStatusVmPaginatedSearchResponse
 */
export interface FailureStatusVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<FailureStatusVm>}
     * @memberof FailureStatusVmPaginatedSearchResponse
     */
    items?: Array<FailureStatusVm> | null;
    /**
     * 
     * @type {number}
     * @memberof FailureStatusVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureStatusVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureStatusVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureStatusVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureStatusVmPaginatedSearchResponse
     */
    size?: number;
}

export function FailureStatusVmPaginatedSearchResponseFromJSON(json: any): FailureStatusVmPaginatedSearchResponse {
    return FailureStatusVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function FailureStatusVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureStatusVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(FailureStatusVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function FailureStatusVmPaginatedSearchResponseToJSON(value?: FailureStatusVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(FailureStatusVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


